import React, { useState } from "react";
import {useTheme} from "next-themes";
import axios from "axios";
import CashbackOffers from "../components/club/CashbackOffers";
import {CashbackDiscoveryProvider} from '../components/club/CashbackDiscoveryContext';
import CashbackMenu from '../components/club/CashbackMenu';

export function installCashbackLivePreview() {
  axios.interceptors.request.use(config => {
    const url = new URL(config.url, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith("/api/alloyal/cashback/")) throw new Error("Destino bloqueado na prévia");
    // The browser supplies the preview's HTTP Basic credential. Never reuse a
    // LOTQ bearer token or persist provider credentials in the client.
    if (config.headers?.delete) config.headers.delete("Authorization");
    else if (config.headers) delete config.headers.Authorization;
    return config;
  });
}

export default function CashbackLivePreview() {
 const [error,setError]=useState('');
 const {resolvedTheme,setTheme}=useTheme();
 return <main className="min-h-screen bg-zinc-950 px-4 py-8 text-white"><div className="mx-auto max-w-6xl">
  <aside className="mb-6 rounded-xl border border-amber-300/30 bg-amber-300/5 p-4 text-sm"><strong>Prévia de UX • catálogo real • sem operações financeiras</strong><p className="mt-1 text-zinc-400">Revise a nova organização. Favoritos de teste ficam neste navegador; saldos, compras e resgates reais não são acessados.</p></aside>
  <button className="mb-4 rounded-lg border border-white/20 px-3 py-2 text-sm" onClick={()=>setTheme(resolvedTheme==='dark'?'light':'dark')}>{resolvedTheme==='dark'?'Visualizar modo claro':'Visualizar modo escuro'}</button>
  <CashbackDiscoveryProvider memberId="preview-catalog" preview>
   <CashbackMenu preview user={{name:'Admin • homologação'}} onProfile={()=>setError('Seu perfil real não é alterado nesta prévia.')} onLogout={()=>setError('Esta prévia usa o acesso protegido da homologação.')}/>
   {error&&<p role="status" className="text-amber-200">{error}</p>}
   <CashbackOffers preview readOnly memberId="preview-catalog" onError={()=>setError('Uma consulta não chegou. Tente novamente.')} onNeedsCpf={()=>setError('Cadastro de teste indisponível.')}/>
  </CashbackDiscoveryProvider>
 </div></main>;
}
